import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { SQUAD_TV_STADIUM_COLORS } from '../../../src/worldcup/constants/squadTvMode.constants';

export const getSquadTvColumnStyles = (theme: Theme) =>
  StyleSheet.create({
    column: {
      flex: 1,
      minWidth: 0,
    },
    columnDivider: {
      borderLeftWidth: 1,
      borderLeftColor: SQUAD_TV_STADIUM_COLORS.borderStrong,
    },
    head: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 40,
      paddingTop: 14,
      paddingBottom: 10,
      borderBottomWidth: 1,
      borderBottomColor: SQUAD_TV_STADIUM_COLORS.border,
    },
    headRank: {
      width: 64,
    },
    headPlayer: {
      flex: 1,
    },
    headPts: {
      width: 150,
      textAlign: 'right',
    },
    headLabel: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 1.6,
      color: theme.gray[400],
      textTransform: 'uppercase',
    },
    viewport: {
      flex: 1,
      overflow: 'hidden',
      position: 'relative',
    },
    track: {
      width: '100%',
    },
    bottomFade: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 64,
    },
  });
